import StoreDBManger from "../../../util/StoreDBManger";
import gcoord from "gcoord";

export const formatterSignType = (signType) => {
    if (!signType) {
        signType = StoreDBManger.getDataWithLocalStorage(StoreDBManger.storageKeys.SELECT_SIGN_TYPE);
        signType = parseInt(signType);
    }
    // （0:待签到，10：已签到，20：抽验，30：签退）
    let signTypeName = "签到";
    switch (signType) {
        case 0:
            signTypeName = "签到";

            break;
        case 1:
            signTypeName = "抽验";

            break;
        case 2:
            signTypeName = "签退";

            break;
        default:
            signTypeName = "签到";
    }
    return signTypeName;
};
/**
 *
 *  获取地区名称
 */
export const getRegionName = (item) => {
    const { province, city, district } = item;
    if (district && district !== "市辖区") {
        return district;
    }
    if (city && !["市辖区", "直辖区"].includes(city)) {
        return city;
    }
    return province || "";
};
/**
 * 格式化Pio地址
 */
export const formatterPoiAddress = (data) => {
    const { address = "", name = "", province = "", city = "", county = "" } = data;

    // 1. 判断是否为直辖市
    const isMunicipality = ["北京市", "上海市", "天津市", "重庆市"].includes(province);

    // 2. 构建【省市区】区域部分（确保完整）
    const regionParts = [];

    // 添加 province
    if (province) {
        regionParts.push(province);
    }

    // 添加 city：仅在非直辖市 或 非无效值时添加
    if (
        city &&
        !isMunicipality && // 直辖市不使用 city（通常为空或“市辖区”）
        city !== "市辖区" &&
        city !== "直辖区" &&
        city !== province
    ) {
        regionParts.push(city);
    }

    // 添加 county：排除无效值
    if (county && county !== "市辖区" && county !== "直辖区") {
        regionParts.push(county);
    }

    // 生成标准区域前缀
    const regionPrefix = regionParts.join("");

    // 3. 提取 address 中的“道路门牌”部分（去除已包含的省市区）
    let detailAddress = address.trim();

    // 清理 address 中可能重复的省、市、区
    [province, city, county].filter(Boolean).forEach((part) => {
        if (!part || ["市辖区", "直辖区"].includes(part)) return;
        const regex = new RegExp(part, "g");
        detailAddress = detailAddress.replace(regex, "");
    });

    // 清理多余空格、标点
    detailAddress = detailAddress
        .trim()
        .replace(/\s+/g, "")
        .replace(/^[:\-\s]+|[:\-\s]+$/g, "");

    // 4. 拼接完整地理地址：regionPrefix + detailAddress
    let finalAddress = regionPrefix;

    // 如果 detailAddress 存在且未被包含，则追加
    if (detailAddress && !finalAddress.includes(detailAddress)) {
        finalAddress += detailAddress;
    }

    // 5. 防止 name 重复添加
    const cleanName = (name + "").trim();
    if (cleanName) {
        // 去除 name 的常见后缀，用于模糊匹配
        const nameWithoutSuffix = cleanName.replace(
            /(公司|局|厅|院|所|店|餐厅|饭店|大厦|大楼|中心|机关|部|馆|学校|医院|广场|园区|厂|站|办事处|办公室|部门)$/g,
            ""
        );

        // 转义特殊字符，构造安全正则
        const escapedName = nameWithoutSuffix.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
        const regex = new RegExp(escapedName, "i");

        // 如果最终地址不包含 name 或模糊匹配不到，则添加
        if (!finalAddress.includes(cleanName) && !regex.test(finalAddress)) {
            finalAddress += "-" + cleanName;
        }
    }

    return finalAddress;
};
/**
 * 坐标转换
 */
export const transformToGCJ02 = (lng, lat) => {
    if (!lng || !lat) return [lng, lat];
    const result = gcoord.transform(
        [lng, lat],
        gcoord.WGS84, // 天地图坐标系（等同于 GCJ-02）
        gcoord.GCJ02
    );
    return result;
};